export enum Steps {
  "DOB_AUTH" = "dob_auth",
  "ORDER_UPDATE" = "order_update",
}
